import { tokens, MUIStyled } from "@cobee/cobee-ui";

export const styles = {
  container: {
    width: "200px",
    height: "100vh",
    flex: "0 0 auto",
    position: "fixed",
    top: 0,
    left: 0,
    right: "auto",
    fontWeight: "normal",
    textDecoration: "none",
    overflowX: "hidden",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: tokens.palette.common.white,
  },
  companyName: {
    color: "#191919",
    overflow: "hidden",
    whiteSpace: "no-wrap",
    textOverflow: "ellipsis",
    ...tokens.typography["Caption-M-400"],
  },
  divider: {
    height: "1px",
    width: "100%",
    backgroundColor: "#eeeeee",
    mt: 1,
    mb: 1,
  },
  optionContainer: {
    width: "168px",
    display: "flex",
    mb: 1,
    textAlign: "left",
  },
  exitButton: {
    width: "100%",
    height: "48px",
    justifyContent: "flex-start",
    borderRadius: "12px",
    backgroundColor: "transparent",
    display: "flex",
    padding: "0 8px",
    paddingX: 2,
    "& svg": {
      mr: 1,
      flexShrink: 0,
    },
    "&:hover": {
      backgroundColor: tokens.palette.grey[300],

      "& svg": {
        color: tokens.palette.grey.A700,
      },

      "& p": {
        color: tokens.palette.grey.A700,
      },
    },
  },
  option: {
    borderRadius: "12px !important",
    width: "148px",
    height: "42px",
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
    backgroundColor: "rgba(0,0,0,0) !important",
    display: "flex",
    justifyContent: "flex-start !important",

    "& span svg": {
      mr: 1,
      color: tokens.palette.grey.A700,
    },

    "> p": {
      textTransform: "capitalize",
      color: tokens.palette.grey.A700,
    },

    "&:hover": {
      backgroundColor: `${tokens.palette.grey[300]} !important`,

      "& svg": {
        color: tokens.palette.grey.A700,
      },
    },
  },
  selectedOption: {
    backgroundColor: `${tokens.palette.purple.darkPressed} !important`,
    "& p": {
      color: tokens.palette.common.white,
      textTransform: "capitalize",
    },
    "& span svg": {
      mr: 1,
      color: tokens.palette.common.white,
    },
    "&:hover": {
      backgroundColor: `${tokens.palette.purple.darkPressed} !important`,
    },
  },
  newLabel: {
    "& p": {
      fontWeight: 500,
    },
  },
  optionText: {
    ...tokens.typography["Body-M-500"],
    width: "auto",
    color: tokens.palette.grey.A700,
  },
  optionDecorator: {
    backgroundColor: "rgba(0,0,0,0)",
    transition: "background-color 0.25s",
    height: "42px",
    width: "8px",
    borderRadius: "0px 12px 12px 0",
    mr: 1,
  },
  selectedOptionDecorator: {
    backgroundColor: tokens.palette.purple.darkPressed,
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    marginBottom: 3,
    width: "100px",
    height: "32px",
    "& img": {
      width: "100px",
      height: "auto",
    },
  },
};

export const CompanyName = MUIStyled("p")({
  color: "#191919",
  whiteSpace: "pre-wrap",
  maxHeight: "3.6em",
  ...tokens.typography["Caption-M-400"],
  fontSize: "14px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  webkitLineClamp: "3",
  webkitBoxOritiend: "vertical",
});
